import { render, staticRenderFns } from "./distributemanWallet.vue?vue&type=template&id=2b1219c4&scoped=true&"
import script from "./distributemanWallet.vue?vue&type=script&lang=js&"
export * from "./distributemanWallet.vue?vue&type=script&lang=js&"
import style0 from "./distributemanWallet.vue?vue&type=style&index=0&id=2b1219c4&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b1219c4",
  null
  
)

export default component.exports